<table class="totals-table">
    <thead>
    <tr>
        <th></th>
        <th>Country</th>
        <th>Sessions</th>
        <th>Events</th>
        <th>Enroll Associate</th>
        <th>Enroll Affiliate</th>
        <th>Enroll PC</th>
        <th>Enroll PC <span style="white-space: nowrap">in Checkout</span></th>
        <th>Enter Checkout</th>
        <th><span style="white-space: nowrap">Returned to</span> Checkout</th>
        <th>Pending Orders</th>
    </tr>
    </thead>
    <tbody>
    <ng-container *ngFor="let countryTotal of countryTotals; let i = index; trackBy: trackByFn">
        <tr>
            <td>
                <button (click)="toggleExpand(i)" class="button-expand">
                    {{ expandedRows[i] ? '-' : '+' }}
                </button>
            </td>
            <td>{{ countryTotal.country }}</td>
            <td class="session-bar-cell"><div class="session-bar" [ngStyle]="getBarStyle(countryTotal.sessions, 'sessions')">{{ countryTotal.sessions }}</div></td>
            <td >{{ countryTotal.events }}</td>
            <td class="enroll-bar-cell"><div class="enroll-bar" [ngStyle]="getBarStyle(countryTotal.associateEnrolls, 'associateEnrolls')">{{ countryTotal.associateEnrolls }}</div></td>
            <td class="enroll-bar-cell"><div class="enroll-bar" [ngStyle]="getBarStyle(countryTotal.affiliateEnrolls, 'affiliateEnrolls')">{{ countryTotal.affiliateEnrolls }}</div></td>
            <td class="enroll-bar-cell"><div class="enroll-bar" [ngStyle]="getBarStyle(countryTotal.pcEnrolls, 'pcEnrolls')">{{ countryTotal.pcEnrolls }}</div></td>
            <td>{{ countryTotal.pcEnrollsWithOrder }}</td>
            <td>{{ countryTotal.cartOrders }}</td>
            <td>{{ countryTotal.updatedCartOrders }}</td>
            <td class="pending-bar-cell"><div class="pending-bar" [ngStyle]="getBarStyle(countryTotal.pendingOrders, 'pendingOrders')">{{ countryTotal.pendingOrders }}</div></td>
        </tr>
        <tr *ngFor="let localeTotal of countryTotal.localeTotals; trackBy: trackByFn" [hidden]="!expandedRows[i]" class="locale-row">
            <td></td>
            <td>{{ localeTotal.locale }}</td>
            <td class="session-bar-cell"><div class="session-bar" [ngStyle]="getBarStyle(localeTotal.sessions, 'sessions')">{{ localeTotal.sessions }}</div></td>
            <td>{{ localeTotal.events }}</td>
            <td class="enroll-bar-cell"><div class="enroll-bar" [ngStyle]="getBarStyle(localeTotal.associateEnrolls, 'associateEnrolls')">{{ localeTotal.associateEnrolls }}</div></td>
            <td class="enroll-bar-cell"><div class="enroll-bar" [ngStyle]="getBarStyle(localeTotal.affiliateEnrolls, 'affiliateEnrolls')">{{ localeTotal.affiliateEnrolls }}</div></td>
            <td class="enroll-bar-cell"><div class="enroll-bar" [ngStyle]="getBarStyle(localeTotal.pcEnrolls, 'pcEnrolls')">{{ localeTotal.pcEnrolls }}</div></td>
            <td>{{ localeTotal.pcEnrollsWithOrder }}</td>
            <td>{{ localeTotal.cartOrders }}</td>
            <td>{{ localeTotal.updatedCartOrders }}</td>
            <td class="pending-bar-cell"><div class="pending-bar" [ngStyle]="getBarStyle(localeTotal.pendingOrders, 'pendingOrders')">{{ localeTotal.pendingOrders }}</div></td>
        </tr>
    </ng-container>
    </tbody>
</table>


